import Tabs from './Tabs';
import tabPropType from './propTypes';

export default Tabs;
export { tabPropType };
